import { useSelectUserContext } from '@innovyze/stylovyze/lib/selectors/userContext.selectors';
import { getS3DataAuthCookies } from '@innovyze/stylovyze/lib/services/dataAuthorizer';
import React, { useCallback, useEffect, useMemo, useState, } from 'react';
import S3DataAuthContext from './S3DataAuthContext';
const S3DataAuthProvider = ({ children, }) => {
    const userContext = useSelectUserContext();
    const [status, setState] = useState('idle');
    const authorizeS3DataCalls = useCallback(() => {
        setState('loading');
        getS3DataAuthCookies()
            .then(() => setState('resolved'))
            .catch(() => setState('rejected'));
    }, []);
    const isUserAuthenticatedInApp = useMemo(() => checkIfUserIsAuthenticatedInApp(userContext), [userContext]);
    const contextValue = useMemo(() => ({
        status,
        authorizeS3DataCalls,
    }), [status, authorizeS3DataCalls]);
    useEffect(() => {
        if (isUserAuthenticatedInApp) {
            authorizeS3DataCalls();
        }
    }, [isUserAuthenticatedInApp]);
    return (React.createElement(S3DataAuthContext.Provider, { value: contextValue }, children));
};
function checkIfUserIsAuthenticatedInApp(userContext) {
    return !!(userContext &&
        userContext.defaultSite &&
        userContext.innovyzeRole);
}
export default S3DataAuthProvider;
